import {
  css as css,
  cx as cx,
} from '@emotion/css';
import { useCallback as useCallback } from 'react';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstanceer3bzpd0z8sw as Companion_getInstance } from '../CouplingImages.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { get_thirdPartyAvatarsDisabledContextbdytsxs1lpoe as get_thirdPartyAvatarsDisabledContext } from '../AnimationsDisabledContext.mjs';
import { ReactHTML_instanceofb06f385x0w as ReactHTML_instance } from '../../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../../kotlin-react/react/create.mjs';
import {
  myGravatarUrlsjogkf8vm6pg as myGravatarUrl,
  gravatarUrl2z6ne5pwiaaxt as gravatarUrl,
} from '../gravatar/GravatarImage.mjs';
import { Random2w0u2xak2xaqi as Random } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { get_entries1xwhtxnyr68s0 as get_entries } from '../../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/player/AvatarType.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  component11fr3arkgy5i01 as component1,
  component21pqhrgr8fz3uo as component2,
  component320i90114p983f as component3,
} from './PlayerCardPropsExtentions.mjs';
import { NotBlankString__toString_impl_5tex9rxgr4zyip8kpr as NotBlankString__toString_impl_5tex9r } from '../../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import { PlayerCardHeader2xkotayfwoj5 as PlayerCardHeader } from './PlayerCardHeaderKt.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_PlayerCard() {
  _init_properties_PlayerCard_kt__fcs3jl();
  var tmp = KProperty0();
  return PlayerCard$delegate.w1m(null, getPropertyCallableRef('PlayerCard', 0, tmp, _get_PlayerCard_$ref_6ztpm1(), null));
}
var PlayerCard$delegate;
function playerCardStyles(_this__u8e3s4, tilt, deselected) {
  _init_properties_PlayerCard_kt__fcs3jl();
  // Inline function 'web.cssom.Position.Companion.relative' call
  _this__u8e3s4.position = 'relative';
  // Inline function 'web.cssom.Clear.Companion.both' call
  _this__u8e3s4.clear = 'both';
  // Inline function 'web.cssom.Display.Companion.inlineBlock' call
  _this__u8e3s4.display = 'inline-block';
  // Inline function 'web.cssom.Overflow.Companion.visible' call
  _this__u8e3s4.overflow = 'visible';
  // Inline function 'web.cssom.px' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0 = toString(3) + 'px';
  // Inline function 'web.cssom.LineStyle.Companion.outset' call
  // Inline function 'web.cssom.Color' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'web.cssom.Border' call
  var color = '#dab8018f';
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.border = toString(tmp0) + ' ' + toString('outset') + ' ' + toString(color);
  // Inline function 'web.cssom.url' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.backgroundImage = 'url(' + Companion_getInstance().y3p_1.l3p_1 + ')';
  // Inline function 'web.cssom.BackgroundRepeat.Companion.repeatX' call
  _this__u8e3s4.backgroundRepeat = 'repeat-x';
  // Inline function 'web.cssom.TextAlign.Companion.center' call
  _this__u8e3s4.textAlign = 'center';
  // Inline function 'web.cssom.None.Companion.none' call
  _this__u8e3s4.textDecoration = 'none';
  // Inline function 'web.cssom.NamedColor.Companion.black' call
  _this__u8e3s4.color = '#000000';
  // Inline function 'web.cssom.px' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_0 = toString(0) + 'px';
  // Inline function 'web.cssom.px' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp2 = toString(2) + 'px';
  // Inline function 'web.cssom.px' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp4 = toString(0) + 'px';
  // Inline function 'web.cssom.px' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'web.cssom.Margin' call
  var left = toString(2) + 'px';
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.margin = toString(tmp0_0) + ' ' + toString(tmp2) + ' ' + toString(tmp4) + ' ' + toString(left);
  // Inline function 'web.cssom.s' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.transitionDuration = toString(0.25) + 's';
  // Inline function 'web.cssom.rotate' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.transform = 'rotate(' + toString(tilt) + ')';
  if (deselected) {
    // Inline function 'web.cssom.px' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.top = toString(30) + 'px';
    // Inline function 'web.cssom.Color' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.backgroundColor = '#ca6363';
  } else {
    // Inline function 'web.cssom.px' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.top = toString(0) + 'px';
    // Inline function 'web.cssom.NamedColor.Companion.darkseagreen' call
    _this__u8e3s4.backgroundColor = '#8FBC8F';
  }
}
function playerCardRuleSet(_this__u8e3s4, size) {
  _init_properties_PlayerCard_kt__fcs3jl();
  var sizeInEm = inCouplingEm(size);
  var totalExtraMarginNeededForImage = 2 * (sizeInEm * 0.02);
  // Inline function 'web.cssom.em' call
  var this_0 = sizeInEm + totalExtraMarginNeededForImage;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.width = toString(this_0) + 'em';
  // Inline function 'web.cssom.em' call
  var this_1 = sizeInEm * 1.4;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.height = toString(this_1) + 'em';
  // Inline function 'web.cssom.em' call
  var this_2 = sizeInEm * 0.04;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.borderWidth = toString(this_2) + 'em';
  // Inline function 'web.cssom.em' call
  var this_3 = sizeInEm * 0.08;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.borderRadius = toString(this_3) + 'em';
  // Inline function 'web.cssom.em' call
  var this_4 = sizeInEm * 0.02;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0 = toString(this_4) + 'em';
  // Inline function 'web.cssom.em' call
  var this_5 = sizeInEm * 0.04;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp2 = toString(this_5) + 'em';
  // Inline function 'web.cssom.em' call
  var this_6 = sizeInEm * 0.04;
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp4 = toString(this_6) + 'em';
  // Inline function 'web.cssom.rgb' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'web.cssom.BoxShadow' call
  var color = 'rgb(' + 0 + ' ' + 0 + ' ' + 0 + ' / ' + 0.6 + ')';
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.boxShadow = toString(tmp0) + ' ' + toString(tmp2) + ' ' + toString(tmp4) + ' ' + toString(color);
  // Inline function 'web.cssom.number' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'web.cssom.number' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'web.cssom.Auto.Companion.auto' call
  // Inline function 'web.cssom.Flex' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.flex = toString(0.0) + ' ' + toString(0.0) + ' ' + toString('auto');
}
function playerGravatarImage(_this__u8e3s4, player, size) {
  _init_properties_PlayerCard_kt__fcs3jl();
  setDefaultKey(_this__u8e3s4, '@rdk/121_110');
  var tmp2 = get_thirdPartyAvatarsDisabledContext().Consumer;
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$Consumer) => {
    $this$Consumer.children = (disabled) => {
      // Inline function 'react.dom.html.ReactHTML.img' call
      // Inline function 'react.IntrinsicType' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = 'img';
      return create(tmp, ($this$create) => {
        $this$create.alt = 'player-icon';
        // Inline function 'emotion.react.css' call
        // Inline function 'emotion.css.ClassName' call
        // Inline function 'js.objects.unsafeJso' call
        // Inline function 'js.objects.unsafeJso' call
        // Inline function 'kotlin.apply' call
        var this_0 = {};
        // Inline function 'web.cssom.em' call
        var this_1 = inCouplingEm(size);
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        this_0.width = toString(this_1) + 'em';
        // Inline function 'web.cssom.em' call
        var this_2 = inCouplingEm(size);
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        this_0.height = toString(this_2) + 'em';
        $this$create.className = css(this_0);
        var tmp;
        if (disabled) {
          tmp = Companion_getInstance().y3p_1.p3p_1;
        } else if (!(player.t2b_1 == null)) {
          tmp = player.t2b_1;
        } else if (!(player.u2b_1 == null)) {
          tmp = getDirectAvatarImageUrl(player, size, ensureNotNull(player.u2b_1));
        } else {
          var tmp0_elvis_lhs = player.u2b_1;
          tmp = getGravatarSafeAvatarImageUrl(player, size, tmp0_elvis_lhs == null ? hashedRandomAvatar(player) : tmp0_elvis_lhs);
        }
        $this$create.src = tmp;
        return Unit_instance;
      });
    };
    return Unit_instance;
  };
  addChild(_this__u8e3s4, tmp2, block);
  return Unit_instance;
}
function inCouplingEm(_this__u8e3s4) {
  _init_properties_PlayerCard_kt__fcs3jl();
  return _this__u8e3s4 / 14.0;
}
function getDirectAvatarImageUrl(_this__u8e3s4, size, avatarType) {
  _init_properties_PlayerCard_kt__fcs3jl();
  var tmp;
  switch (avatarType.b2_1) {
    case 0:
      // Inline function 'com.zegreatrob.coupling.client.components.gravatar.GravatarOptions.Companion.invoke' call

      // Inline function 'com.zegreatrob.coupling.client.components.gravatar.com_zegreatrob_coupling_client_components_gravatar_GravatarOptions_Companion_1l6t1y_invoke_jkqnwo' call

      var tmp$ret$1 = {'default': 'retro', size: size};
      tmp = myGravatarUrl(tmp$ret$1, emailWithFallback(_this__u8e3s4), null);
      break;
    case 1:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set1');
      break;
    case 2:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set2');
      break;
    case 3:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set3');
      break;
    case 4:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set4');
      break;
    case 5:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set5');
      break;
    case 6:
      tmp = multiavatarUrl(_this__u8e3s4, 'svg');
      break;
    case 7:
      tmp = dicebearUrl(_this__u8e3s4, 'pixel-art', size, 'svg');
      break;
    case 8:
      tmp = dicebearUrl(_this__u8e3s4, 'adventurer', size, 'svg');
      break;
    case 9:
      tmp = dicebearUrl(_this__u8e3s4, 'croodles', size, 'svg');
      break;
    case 10:
      tmp = dicebearUrl(_this__u8e3s4, 'thumbs', size, 'svg');
      break;
    case 11:
      tmp = dicebearUrl(_this__u8e3s4, 'lorelei', size, 'svg');
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function getGravatarSafeAvatarImageUrl(_this__u8e3s4, size, avatarType) {
  _init_properties_PlayerCard_kt__fcs3jl();
  var tmp;
  switch (avatarType.b2_1) {
    case 1:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set1', '&gravatar=yes');
      break;
    case 2:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set2', '&gravatar=yes');
      break;
    case 3:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set3', '&gravatar=yes');
      break;
    case 4:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set4', '&gravatar=yes');
      break;
    case 5:
      tmp = getRobohashImageUrl(_this__u8e3s4, 'set5', '&gravatar=yes');
      break;
    case 6:
      tmp = gravatarWrapper(multiavatarUrl(_this__u8e3s4, 'png'), emailWithFallback(_this__u8e3s4), size);
      break;
    case 7:
      tmp = gravatarDicebearUrl(_this__u8e3s4, 'pixel-art', size);
      break;
    case 8:
      tmp = gravatarDicebearUrl(_this__u8e3s4, 'adventurer', size);
      break;
    case 9:
      tmp = gravatarDicebearUrl(_this__u8e3s4, 'croodles', size);
      break;
    case 10:
      tmp = gravatarDicebearUrl(_this__u8e3s4, 'thumbs', size);
      break;
    case 11:
      tmp = gravatarDicebearUrl(_this__u8e3s4, 'lorelei', size);
      break;
    default:
      // Inline function 'com.zegreatrob.coupling.client.components.gravatar.GravatarOptions.Companion.invoke' call

      // Inline function 'com.zegreatrob.coupling.client.components.gravatar.com_zegreatrob_coupling_client_components_gravatar_GravatarOptions_Companion_1l6t1y_invoke_jkqnwo' call

      var tmp$ret$1 = {'default': 'retro', size: size};
      tmp = myGravatarUrl(tmp$ret$1, emailWithFallback(_this__u8e3s4), null);
      break;
  }
  return tmp;
}
function hashedRandomAvatar(_this__u8e3s4) {
  _init_properties_PlayerCard_kt__fcs3jl();
  // Inline function 'kotlin.let' call
  var p0 = getStringHashCode(emailWithFallback(_this__u8e3s4));
  // Inline function 'kotlin.let' call
  var it = Random(p0).g2(get_entries().v2());
  return get_entries().w2(it);
}
function emailWithFallback(_this__u8e3s4) {
  _init_properties_PlayerCard_kt__fcs3jl();
  return !(_this__u8e3s4.q2b_1 === '') ? _this__u8e3s4.q2b_1 : !(_this__u8e3s4.p2b_1 === '') ? _this__u8e3s4.p2b_1 : 'name';
}
function getRobohashImageUrl(_this__u8e3s4, setName, additionalArgs) {
  additionalArgs = additionalArgs === VOID ? '' : additionalArgs;
  _init_properties_PlayerCard_kt__fcs3jl();
  return 'https://robohash.org/' + emailWithFallback(_this__u8e3s4) + '?set=' + setName + additionalArgs;
}
function multiavatarUrl(_this__u8e3s4, type) {
  _init_properties_PlayerCard_kt__fcs3jl();
  return 'https://api.multiavatar.com/' + emailWithFallback(_this__u8e3s4) + '.' + type;
}
function dicebearUrl(_this__u8e3s4, set, size, type) {
  _init_properties_PlayerCard_kt__fcs3jl();
  return 'https://api.dicebear.com/6.x/' + set + '/' + type + '/seed=' + emailWithFallback(_this__u8e3s4) + '&size=' + size;
}
function gravatarWrapper(_this__u8e3s4, email, size) {
  _init_properties_PlayerCard_kt__fcs3jl();
  // Inline function 'com.zegreatrob.coupling.client.components.gravatar.GravatarOptions.Companion.invoke' call
  // Inline function 'com.zegreatrob.coupling.client.components.gravatar.com_zegreatrob_coupling_client_components_gravatar_GravatarOptions_Companion_1l6t1y_invoke_jkqnwo' call
  var tmp$ret$1 = {'default': encodeURIComponent(_this__u8e3s4), size: size};
  return gravatarUrl(email, tmp$ret$1);
}
function gravatarDicebearUrl(_this__u8e3s4, set, size) {
  _init_properties_PlayerCard_kt__fcs3jl();
  return gravatarWrapper(dicebearUrl(_this__u8e3s4, set, size, 'png'), emailWithFallback(_this__u8e3s4), size);
}
function PlayerCard$delegate$lambda($this$nfc, props) {
  _init_properties_PlayerCard_kt__fcs3jl();
  var player = component1(props);
  var className = component2(props);
  var onClick = component3(props);
  var tmp0 = [onClick];
  // Inline function 'react.useCallback' call
  var callback = (it) => {
    var tmp0_safe_receiver = onClick;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    return Unit_instance;
  };
  var onClickFunc = useCallback(callback, tmp0);
  var tmp0_elvis_lhs = props.size;
  var size = tmp0_elvis_lhs == null ? 100 : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = props.tilt;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'web.cssom.deg' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = toString(0) + 'deg';
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var tilt = tmp;
  var deselected = props.deselected === true;
  setDefaultKey($this$nfc, '@rdk/64_14');
  // Inline function 'react.dom.html.ReactHTML.div' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$div) => {
    // Inline function 'emotion.react.css' call
    // Inline function 'emotion.css.ClassName' call
    var tmp0 = [className].slice();
    // Inline function 'emotion.css.ClassName' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_0 = {};
    playerCardStyles(this_0, tilt, deselected);
    // Inline function 'csstype.RuleBuilder.invoke' call
    // Inline function 'web.cssom.Selector' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'csstype.RuleBuilder.invoke' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_1 = {};
    // Inline function 'web.cssom.Display.Companion.block' call
    this_1.display = 'block';
    this_0['img'] = this_1;
    playerCardRuleSet(this_0, size);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$29 = [css(this_0)];
    var tmp$ret$30 = tmp0.concat(tmp$ret$29);
    $this$div.className = cx.apply(null, [].slice.call(tmp$ret$30.slice()));
    // Inline function 'kotlin.js.asDynamic' call
    $this$div['data-player-id'] = NotBlankString__toString_impl_5tex9r(player.n2b_1.n2c_1);
    // Inline function 'kotlin.js.asDynamic' call
    $this$div['data-selected'] = '' + !deselected;
    $this$div.onClick = onClickFunc;
    setDefaultKey($this$div, '@rdk/73_18');
    // Inline function 'react.dom.html.ReactHTML.div' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block = ($this$div) => {
      // Inline function 'emotion.react.css' call
      // Inline function 'emotion.css.ClassName' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'kotlin.apply' call
      var this_0 = {};
      // Inline function 'web.cssom.px' call
      var this_1 = size * 0.02;
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.margin = toString(this_1) + 'px';
      // Inline function 'web.cssom.em' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.perspective = toString(15) + 'em';
      $this$div.className = css(this_0);
      playerGravatarImage($this$div, player, size);
      PlayerCardHeader($this$div, player, size);
      return Unit_instance;
    };
    addChild($this$div, 'div', block);
    return Unit_instance;
  };
  addChild($this$nfc, 'div', block);
  return Unit_instance;
}
function _get_PlayerCard_$ref_6ztpm1() {
  return () => get_PlayerCard();
}
var properties_initialized_PlayerCard_kt_t4oa8d;
function _init_properties_PlayerCard_kt__fcs3jl() {
  if (!properties_initialized_PlayerCard_kt_t4oa8d) {
    properties_initialized_PlayerCard_kt_t4oa8d = true;
    PlayerCard$delegate = nfc(PlayerCard$delegate$lambda);
  }
}
//region block: exports
export {
  get_PlayerCard as get_PlayerCard1h4x7zc5wjxwf,
};
//endregion

//# sourceMappingURL=PlayerCard.mjs.map
